import type { QueryFunctionContext } from '@tanstack/react-query';
import { AdminTranscriptReviewService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { adminTranscriptReviewKeys } from 'app/queries/adminTranscriptReview/adminTranscriptReviewKeys';
import type { TCall } from 'app/queries/types/TCall';
import { normalizeSessions } from '../helpers/sessions';

type TParams = QueryFunctionContext<ReturnType<typeof adminTranscriptReviewKeys.sessionsByJob>>;

export const createFetchTranscriptReviewSessionsQueryFn =
  (call: TCall) =>
  async ({ queryKey: [{ jobId }], signal }: TParams) =>
    normalizeSessions(
      await call(() => cancelOnSignal(AdminTranscriptReviewService.listSessionsForJob({ jobId }), signal), {
        dontRedirectOnError: true,
      }),
    );
